import React from "react"
import {DataInput, DragDropFile} from "./file-input";
import {valueOrEmpty} from "../../../../utils/number";


export class ImportMeasurements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data || [],
            fileName: props.fileName
        };
    };

    componentWillReceiveProps(props) {
        this.setState({
            data: props.data || [],
            fileName: props.fileName
        })
    }

    onImportSuccess = (data, fileName) => {
        const requestData = {
            measurements: data.slice(1, data.length).map(d => { // first element is the header

                if (d.length === 0) {
                    return undefined
                }

                const characteristic = this.props.characteristics.find(c => c.shortcut === d[0])

                return {
                    characteristic: d[0],
                    values: [...Array(10).keys()]
                        .map(i => d[i + 1] ? `${d[i + 1].toString().toLowerCase().replace(/,/g, '.').replace(/nok/g, 'false').replace(/ok/g, 'true')}` : ''),
                    existsOnTemplate: characteristic !== undefined,
                    id: characteristic ? characteristic.id : undefined
                }
            }).filter(d => typeof d !== 'undefined')
        }

        this.props.importSuccess(requestData.measurements, fileName)
        this.setState({data: requestData.measurements})
    }

    clear = () => {
        this.props.clear()
        this.setState({data: [], fileName: undefined})
    }


    render() {
        const {t} = this.props
        const data = this.state.data.map(d => {
            const characteristic = this.props.characteristics.find(c => c.shortcut === d.characteristic)
            return {
                ...d,
                existsOnTemplate: characteristic !== undefined
            }
        })

        return (
            <div className="row">
                <div className="col-2">
                    <DataInput handleFile={this.handleFile} onImportSuccess={this.onImportSuccess}
                               fileName={this.state.fileName}
                               t={t}/>
                </div>
                <div className="col-10" style={{color: 'orange'}}>
                    <div className={"row "}>
                        <div className={"col-12 "}>
                            <button type="button" className="button" size="small" onClick={this.clear}>{t('general.clear')}
                            </button>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12"} style={{paddingLeft: "20px", color: "orange"}}>
                            {
                                data.filter(d => d.existsOnTemplate === false).length > 0 ?
                                    t('reports_create.some_characteristics_wont_be_imported') : ''
                            }
                        </div>
                    </div>

                </div>
            </div>
        );
    };
}


export class ImportOutTable extends React.Component {
    constructor(props) {
        super(props);
    };

    render() {
        const {t} = this.props
        return (
            <div className="table-responsive" style={{marginTop: "20px"}}>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <td>{t('characteristics.characteristic')}</td>
                        {
                            [...Array(10).keys()].map(i => <td key={i}>{i + 1}</td>)
                        }
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.props.data.map((d, index) => {
                            return (
                                <tr key={index}>
                                    <td style={{color: d.existsOnTemplate ? 'black' : 'orange'}}>{d.characteristic}</td>
                                    {
                                        [...Array(10).keys()].map(i => <td
                                            key={i}>{valueOrEmpty(d.values[i])}</td>)
                                    }
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        );
    };
}
